<div class="filter-container">

  <!-- TASTO FILTRO -->
  <button
    type="button"
    class="filter-button"
    (click)="toggleMenu($event)"
  >
    <span class="filter-icon">
      <span></span>
      <span></span>
      <span></span>
    </span>
  </button>


  <!-- MENU -->
  <div
    class="filter-menu"
    *ngIf="opened"
    (click)="$event.stopPropagation()"
  >

    <div class="filter-menu-header">
      <span>Filtra per</span>

      <button
        type="button"
        class="clear-button"
        (click)="clearFilters()"
      >
        Cancella tutto
      </button>
    </div>




    <ng-container *ngFor="let filter of FilterList">

      <div
        class="filter-item"
        [class.active]="filter.active"
        (mouseenter)="activeMenuChanged(filter)"
      >
        <div class="filter-item-left">
          <span [innerHTML]="filter.iconHtml"></span>
          <span>{{filter.name}}</span>
        </div>

        <span class="arrow">›</span>
      </div>


      <div
        class="filter-submenu"
        *ngIf="filter.active"
      >

        <div *ngFor="let option of filter.Campi"
          class="submenu-item"
             [class.active]="option.active"
          (click)="option.func(option, this, filter)"
        >
          <i class="fa fa-check" *ngIf="option.active" style="color: var(--main-color)"></i>
          <span [innerHTML]="filter.iconHtml"></span>
          <span>{{option.name}}</span>
        </div>

      </div>

    </ng-container>



  </div>

</div>
